// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__4ZmMJ","size":"style_size__RFlJO","spin":"style_spin___6Lpi"};